import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProdutoListComponent } from './produto-list/produto-list.component';
import { ProdutoFormComponent } from './produto-form/produto-form.component';
import { ProdutoViewComponent } from './produto-view/produto-view.component';
import { AuthGuard } from 'eddydata-lib';

const routes: Routes = [
  { path: '', component: ProdutoListComponent, canActivate: [AuthGuard] },
  { path: 'novo', component: ProdutoFormComponent, canActivate: [AuthGuard] },
  { path: ':id/editar', component: ProdutoFormComponent, canActivate: [AuthGuard] },
  { path: ':id/visualizar', component: ProdutoViewComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProdutoRoutingModule { }
